import { Route, Routes, Navigate } from "react-router-dom";
import Customers from "../../Pages/Customers";
import Dashboard from "../../Pages/Dashboard";
import Inventory from "../../Pages/Inventory";
import Orders from "../../Pages/Orders";
import Contacts from "../../Pages/Contacts";
import TemplateList from "../../Pages/TemplateList";
import Transaction from "../../Pages/Transaction";
import SegmentList from "../../Pages/SegmentList";
import Promotion from "../../Pages/Promotion";
import CampaignList from "../../Pages/CampaignList";
import Campaign from "../../Pages/Campaign";
import Consultant from "../../Pages/Consultant";
import NewSegment from "../../Pages/NewSegment";
import MessageLog from "../../Pages/MessageLog";
import Profile from "../../Pages/Profile";
import Connections from "../../Pages/Connections";
import Billing from "../../Pages/Billing";
import Payroll from "../../Pages/Payroll";
import OAAccountList from "../../Pages/OAAccountList";
import OAAccount from "../../Pages/OAAccount";
import PackageList from "../../Pages/PackageList";
import Packages from "../../Pages/Package";
import PackagesOAList from "../../Pages/PackagesOAList";
import PackagesOA from "../../Pages/PackagesOA";
import AllUserList from "../../Pages/AllUserList";
import AllUserDeletedList from "../../Pages/AllUserDeletedList";
import { ADMINS_EMAILS } from "../../config";
import SubUser from "../../Pages/SubUser";
import SubUserList from "../../Pages/SubUserList";
import OASubAccountList from "../../Pages/OASubAccountList";
import OASubAccount from "../../Pages/OASubAccount";
import { useGlobalContext } from "../../providers/GlobalProvider";
import PayrollList from "../../Pages/PayrollList";
import GMF from "../../Pages/GMF";
import MessageLogPayroll from "../../Pages/MessageLogPayroll";
import ZNSTemplate from "../../Pages/ZNSTemplate";
import ZNSList from "../../Pages/ZNSList";
import ZNS from "../../Pages/ZNS";
import MessageLogZNS from "../../Pages/MessageLogZNS";


function AppRoutes() {
  const {isPayroll} = useGlobalContext();
  const user = JSON.parse(localStorage.getItem('user'));
  const msgTypes = ["consultant", "transaction", "promotion"];
  const component = {
    consultant:(msgType) => <Consultant tplType={msgType}/>,
    transaction:(msgType) => <Transaction tplType={msgType}/>,
    promotion:(msgType) => <Promotion tplType={msgType}/>,
  }
  return (
    <Routes>
      <Route path="*" element={<Navigate to={!ADMINS_EMAILS.includes(user.email)? '/dashboard': '/profile'} replace={true} />} />
      <Route path="/profile" element={<Profile />}></Route>
      {!ADMINS_EMAILS.includes(user.email) && (
        <>
        <Route path="/dashboard" element={<Dashboard />}/>
        <Route path="/inventory" element={<Inventory />}></Route>
        <Route path="/orders" element={<Orders />}></Route>
        <Route path="/billing" element={<Billing />}></Route>
        <Route path="/customers" element={<Customers />}></Route>
        <Route path="oaaccounts" >
          <Route path="" element={<OAAccountList />}/>
          <Route path="new" element={<OAAccount/>} />
          <Route path="edit" element={<OAAccount/>} />
        </Route>
        <Route path="znstemplate" element={<ZNSTemplate/>}></Route>
        <Route path="znscamapaign" >
          <Route path="" element={<ZNSList />}/>
          <Route path="new" element={<ZNS/>} />
          <Route path="edit" element={<ZNS/>} />
        </Route>
        <Route path="/messagelogzns" element={<MessageLogZNS/>}/>
        { !(user?.parentId) && 
        <>
          <Route path="/connections" element={<Connections />}/>
          <Route path="subusers" >
            <Route path="" element={<SubUserList />}/>
            <Route path="new" element={<SubUser/>} />
            <Route path="edit" element={<SubUser/>} />
          </Route>
          <Route path="/oasubaccounts">
            <Route path="" element={<OASubAccountList/>}/>
            <Route path="new" element={<OASubAccount/>}/>
            <Route path="edit" element={<OASubAccount/>}/>
          </Route> 
        </>}
        {isPayroll &&
          <>
            <Route path="/payroll">
              <Route path="" element={<PayrollList/>}/>
              <Route path="new" element={<Payroll/>}/>
            </Route>
            <Route path="messagelogpayroll" element={<MessageLogPayroll/>}/>
          </>
        }
          <Route path="/contacts">
            <Route path="all" element={<Contacts />} />
            <Route path="gmf" element={<GMF />} />
            <Route path="segments">
              <Route path="" element={<SegmentList />} />
              <Route path="new" element={<NewSegment />} />
              <Route path="edit/:segmentId" element={<NewSegment />} />
            </Route>
          </Route>
          <Route path="template">
            {msgTypes.map((msgType, i) => (
                <Route path={`${msgType}s`} key={i}>
                  <Route path="" element={<TemplateList tplType={msgType} />} />
                  <Route path="new" element={component[msgType](msgType)} />
                  <Route path="edit" element={component[msgType](msgType)} />
                </Route>
            ))}
          </Route>
          <Route path="send">
            {msgTypes.map((msgType, i) => (
              <Route path={`${msgType}s`} key={i}>
                <Route path="" element={<CampaignList cmpType={msgType} />} />
                <Route path="new" element={<Campaign cmpType={msgType} />} />
                <Route path="edit" element={<Campaign cmpType={msgType} />} />
              </Route>
            ))}
            <Route path='gmfconsultants'>
                <Route path="" element={<CampaignList cmpType='gmfconsultant'/>} />
                <Route path="new" element={<Campaign cmpType='consultant' group/>} />
                <Route path="edit" element={<Campaign cmpType='consultant' group/>} />
              </Route>
          </Route>
          <Route path="/messagelog" element={<MessageLog/>}/>
      </>)}
      {ADMINS_EMAILS.includes(user.email) && (
        <>
        <Route path="packages" >
          <Route path="" element={<PackageList />}/>
          <Route path="new" element={<Packages/>} />
          <Route path="edit" element={<Packages/>} />
        </Route>
        <Route path="packagesoa" >
          <Route path="" element={<PackagesOAList />}/>
          <Route path="new" element={<PackagesOA/>} />
          <Route path="edit" element={<PackagesOA/>} />
        </Route>
        <Route path="allusers" >
          <Route path="" element={<AllUserList />}/>
        </Route>
        <Route path="allusersdeleted" >
          <Route path="" element={<AllUserDeletedList />}/>
        </Route>
        </>
      )}
    </Routes>
  );
}
export default AppRoutes;
